import React , { useState , useEffect } from 'react';
import { Link , NavLink } from 'react-router-dom';
import menus from '../../pages/menu';
import './styles.scss';
import logo from '../../assets/images/logo/logo_dark.png';
import logodark from '../../assets/images/logo/logo.png';
import DarkMode from './DarkMode';

const Header = () => {
    const [scroll, setScroll] = useState(false);
        useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 100);
        });
        return () => {
            setScroll({});
        }
    }, []);

    const [menuActive, setMenuActive] = useState(false);

    const handleMenuActive = () => {
        setMenuActive(!menuActive);
    };

    const closeMenu = () => {
        setMenuActive(false);
        setActiveIndex(null);
    };

    useEffect(() => {
        document.body.style.overflow = menuActive ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        }
    }, [menuActive]);

    const [activeIndex, setActiveIndex] = useState(null);
    const handleDropdown = index => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <header className={`header ${scroll ? 'is-fixed' : ''}`}>
            <div className="tf-container">
                <div className="header-bar">
                    <Link to="/" rel="home" className="header-logo">
                        <img className='logo-dark' src={logo} alt="Aljariyah" />
                        <img className='logo-light' src={logodark} alt="Aljariyah" />
                    </Link>

                    <nav id="main-nav" className={`header-nav ${menuActive ? 'active' : ''}`}>
                        <div className="header-nav-head">
                            <span className="header-nav-title">Menu</span>
                            <button type="button" className="header-nav-close" onClick={closeMenu} aria-label="Tutup menu">
                                <i className="fas fa-times"></i>
                            </button>
                        </div>

                        <ul className="header-nav-list">
                            {
                                menus.map((data,idx) => (
                                    <li key={idx} className={`header-nav-item ${data.namesub || data.subs ? 'has-sub' : ''} ${activeIndex === idx ? 'active' : ''}`}>
                                        <Link to={data.links} onClick={() => data.namesub || data.subs ? handleDropdown(idx) : closeMenu()}>
                                            {data.name}
                                            {(data.namesub || data.subs) && <i className="fas fa-chevron-down"></i>}
                                        </Link>
                                        {
                                            data.namesub &&
                                            <ul className="header-sub-menu">
                                                {
                                                    data.namesub.map((submenu) => (
                                                        <li key={submenu.id}><NavLink to={submenu.links} target="_blank" onClick={closeMenu}>{submenu.sub}</NavLink></li>
                                                    ))
                                                }
                                            </ul>
                                        }
                                        {
                                            data.subs &&
                                            <ul className="header-sub-menu">
                                                {
                                                    data.subs.map((submenu) => (
                                                        <li key={submenu.id}><NavLink to={submenu.links} onClick={closeMenu}>{submenu.name}</NavLink></li>
                                                    ))
                                                }
                                            </ul>
                                        }
                                    </li>
                                ))
                            }
                        </ul>
                    </nav>

                    <div className="header-actions">
                        <Link to="https://play.google.com/store/apps/details?id=com.al_jariyah&hl=ms&gl=US" target='_blank' className="header-download-link">
                            Muat Turun
                        </Link>

                        <DarkMode />

                        <button
                            type="button"
                            className={`header-menu-toggle ${menuActive ? 'active' : ''}`}
                            onClick={handleMenuActive}
                            aria-label="Buka menu"
                        >
                            <span className="header-menu-toggle-bars">
                                <span></span>
                                <span></span>
                                <span></span>
                            </span>
                        </button>
                    </div>
                </div>
            </div>

            {menuActive && <div className="header-nav-backdrop" onClick={closeMenu}></div>}
        </header>
    );
}

export default Header;